<template>
  <div class="tutor-list">
    <div class="list-table__title">Tutor List</div>
    <b-table
      striped
      hover
      fixed
      Outlined
      show-empty
      :empty-text="'No data available'"
      :items="tutors"
      :fields="fields"
      :table-class="'list-table text-center'"
      :thead-class="'list-table__head'"
      :tbody-class="'list-table__body'"
    >
      <template #head(select)>
        <label class="checkbox">
          <input
            @change="selectAll($event)"
            type="checkbox"
            :value="pager.current"
            v-model="selectedAllCheckForPages"
          >
        </label>
      </template>
      <template #cell(select)="tutor">
        <label class="checkbox">
          <input
            :value="tutor.item.id"
            type="checkbox"
            v-model="selectedTutorIds"
          >
        </label>
      </template>
      <template #head(id)="data">
        <div
          @click="sortByTutorId()"
          :class="sortDirection"
        >{{ data.label }}
        </div>
      </template>
      <template #cell(Details)="tutor">
        <div>
          <div>
            <b-button
              pill
              variant="outline-secondary"
              :to="{name: 'TutorDetail', params: { id: tutor.item.id }}"
              class="w-100 min-width-initial"
            >
              Details
            </b-button>
          </div>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Moment } from 'moment';
import _ from 'lodash'
import { Position } from '@/store/master/types';
import { TravelExpense, Tutor } from '@/store/tutors/types';
import Pager from '@/components/parts/Pager.vue';
import { TutorSearchConditions } from './TutorMailTemplateSearch.vue';

@Component
export default class TutorTable extends Vue {
  @Prop({}) tutors!: Tutor[]

  @Prop({}) pager!: Pager[]

  @Prop({}) conditions!: TutorSearchConditions|null

  selectedTutorIds: string[] = []

  private selectedAllCheckForPages: number[] = []

  private sortDirection: 'asc'|'desc'|null = null

  private fields: Array<Object> = [
    {
      key: 'select',
      label: 'Select',
    },
    {
      key: 'id',
      label: 'Tutor ID',
    },
    {
      key: 'name',
      label: 'Tutor Name',
    },
    {
      key: 'position',
      label: 'Position',
      formatter: (position: Position) => position.name,
    },
    {
      key: 'hireDate',
      label: 'Start Date',
      formatter: (hireDate: Moment|undefined) => hireDate && hireDate.format('YYYY/MM/DD'),
    },
    {
      key: 'phone1',
      label: 'Phone',
    },
    {
      key: 'email1',
      label: 'Email',
    },
    {
      key: 'travelExpenses',
      label: 'Nearest Station',
      formatter: (expenses: TravelExpense[]) => {
        return _.chain(expenses).map('nearestStation').first().value()
      },
    },
    { key: 'Details' },
  ]

  private get current(): number {
    return this.$store.state.tutors.pager.current
  }

  private selectAll(event: {target: HTMLInputElement}) {
    const tutorIds: string[] = _.map(this.tutors, 'id')

    _.pull(this.selectedTutorIds, ...tutorIds)

    if (event.target.checked) {
      this.selectedTutorIds.push(...tutorIds)
    }
  }

  private sortByTutorId() {
    const directions = ['asc', 'desc', null]
    const directionPosition = _.indexOf(directions, this.sortDirection)
    this.sortDirection = directions[(directionPosition + 1) % 3] as 'asc'|'desc'|null

    if (this.sortDirection) {
      this.$store.dispatch('fetchTutors', {
        conditions: this.conditions,
        page: this.current,
        sortBy: { key: 'tutorId', direction: this.sortDirection },
      })
    }
  }
}
</script>

<style>
.tutor-list .list-table .list-table__head th {
  font-size: .6rem;
  vertical-align: middle;
  white-space: pre-line;
}

.tutor-list .list-table .list-table__body td {
  font-size: .5rem;
  padding: 1rem .5rem;
  word-break: break-all;
}
.tutor-list .list-table .list-table__body td[aria-colindex="6"] {
  overflow-wrap:break-word;
}

.checkbox {
  margin-bottom: 0;
}

.checkbox input {
  vertical-align: middle;
}
.asc::after {
  margin-left:5px;
  content: "▼";
}

.desc::after {
  margin-left:5px;
  content: "▲";
}
</style>
